import { useState, useEffect } from 'react'
import { useUserDetails } from '@pepper/ui'
import { getUserId } from '@pepper/utils/src/api/functions/authHelpers'
import { useSelectedCompanyId } from 'utils/functions/misc'

export default function useUserAccountType(): ClientAccountType | null {
  const userId = getUserId()
  const companyId = useSelectedCompanyId()
  const [accountType, setAccountType] = useState<ClientAccountType | null>(null)

  const { userDetails, isUserDetailsLoading } = useUserDetails(userId)

  useEffect(() => {
    if (!isUserDetailsLoading && userDetails) {
      setAccountType(
        userDetails.companies.find(company => company.id === companyId)?.type ??
          'standard'
      )
    }
  }, [userDetails, isUserDetailsLoading, companyId])

  return accountType
}
